import React from "react";

function NotesHeader() {
  return (
    <div style={{ marginBottom: "40px" }}>
      <h1>Notes</h1>

      {/* <p style={{ opacity: 0.8, maxWidth: "700px" }}>
        Short, focused explanations of concepts I frequently use.
        These are meant to be referenced, not read linearly.
      </p> */}
    </div>
  );
}

export default NotesHeader;
